module.exports = __webpack_public_path__ + "static/media/urgency.aceda2f9.png";